import type { TSerializedWidget } from 'src/entities/workspace/types';
import { mergeReferenceWellsIntoSerializedWidget } from 'src/packages/reference-wells-persistence/merge-reference-wells-into-serialized-widget';
import type {
  TTrajectorySerializedInternalState,
  TrajectoryWidgetEntity,
} from 'src/pages/dashboard/features/trajectory-widget/TrajectoryWidget.entity';

export function serializeTrajectoryWidget(widget: TrajectoryWidgetEntity): TSerializedWidget {
  const internalState: TTrajectorySerializedInternalState = {
    wellId: widget.wellId,
    wellboreId: widget.wellboreId,
    trajectoryId: widget.trajectoryId,
    planOrFact: widget.planOrFact,
    stateParams: { ...widget.stateParams },
  };

  const serialized: TSerializedWidget = {
    wellId: widget.wellId,
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    isFullscreen: widget.isFullscreen,
    internalState,
  };

  return mergeReferenceWellsIntoSerializedWidget(serialized, widget);
}
